import { useEffect, useState } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72034c2-4f95-4f18-be74-1d29b1871fdc/artifacts/djdyqu9t_IMG_1381.png";

/**
 * Splash de Refugium.
 * Se muestra al abrir la app y cada vez que el usuario vuelve tras un rato de inactividad.
 * El logo se muestra limpio (sin halos ni redondos) y solo la llama cambia de
 * color/intensidad para dar la sensación de "encendida".
 * Duración total: ~2.4s. Se llama onDone al terminar.
 */
export default function SplashScreen({ onDone }) {
  // Fases: 0 = inicio, 1 = llama encendida, 2 = fade-out
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 200);
    const t2 = setTimeout(() => setPhase(2), 1900);
    const t3 = setTimeout(() => onDone && onDone(), 2400);
    return () => { [t1, t2, t3].forEach(clearTimeout); };
  }, [onDone]);

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-500 ${
        phase >= 2 ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      style={{ backgroundColor: "#F5EEDB" }}
      aria-hidden={phase >= 2}
    >
      <div className="relative">
        {/* Logo tal cual, sin máscara ni halos */}
        <img
          src={LOGO_URL}
          alt="Refugium"
          className="relative w-64 h-64 sm:w-80 sm:h-80 object-contain"
          draggable={false}
        />

        {/* Ciclo de color sobre la zona de la llama del logo — parpadeo tipo hoguera */}
        {phase >= 1 && (
          <div
            className="absolute pointer-events-none"
            style={{
              // Posición aproximada de la llama dentro de la cabaña del logo
              left: "50%",
              top: "62%",
              width: "18%",
              height: "18%",
              transform: "translate(-50%, -50%)",
              borderRadius: "50%",
              mixBlendMode: "screen",
              filter: "blur(4px)",
              animation: "flame-cycle 1.4s ease-in-out infinite",
            }}
          />
        )}
      </div>

      <style>{`
        @keyframes flame-cycle {
          0%   { background: radial-gradient(circle, rgba(255,180,60,0.85) 0%, transparent 65%); transform: translate(-50%, -50%) scale(1); }
          25%  { background: radial-gradient(circle, rgba(255,120,40,0.90) 0%, transparent 60%); transform: translate(-50%, -55%) scale(1.08); }
          50%  { background: radial-gradient(circle, rgba(255,220,90,0.80) 0%, transparent 70%); transform: translate(-50%, -48%) scale(0.95); }
          75%  { background: radial-gradient(circle, rgba(255,140,50,0.90) 0%, transparent 62%); transform: translate(-50%, -53%) scale(1.05); }
          100% { background: radial-gradient(circle, rgba(255,180,60,0.85) 0%, transparent 65%); transform: translate(-50%, -50%) scale(1); }
        }
      `}</style>
    </div>
  );
}
